<!-- non-login -->
<!-- <div class="container">
  <div *ngIf="!isAuthenticated()" class="row my-4 d-block d-sm-none">
    <div class="col d-flex flex-row-reverse">
      <app2-menu-translation></app2-menu-translation>
    </div>
  </div>

  <div id="mainNavbar" class="row mt-4 mb-4 desktop">
    <div class="col-md-6 d-flex" style="align-items: center">
      <span
        style="
          display: flex;
          font-size: 14px;
          padding-right: 20px;
          font-weight: bold;
        "
      >
        <i
          class="bi bi-telephone"
          style="padding-right: 8px; color: #001b3f"
        ></i>
        <p style="color: #001b3f">AllianzCare 1500136</p>
      </span>
    </div>

    <div class="col-md-6">
      <div class="d-flex" style="justify-content: flex-end">
        <app2-menu-translation></app2-menu-translation>
        <app2-menu-profile *ngIf="isAuthenticated()"></app2-menu-profile>
      </div>
    </div>
  </div>

  <div *ngIf="!isAuthenticated()" class="isHideInMobile">
    <div class="border"></div>

    <div class="row" style="height: 65px">
      <div
        class="col"
        style="
          display: flex;
          gap: 42px;
          align-items: baseline;
          padding-top: 1rem;
        "
      >
        <app2-allianz-logo></app2-allianz-logo>
        <a routerLink="/public/contact">
          <h6 style="color: #001b3f">{{wording.global.menu.contact}}</h6>
        </a>
        <a routerLink="/public/faq">
          <h6 style="color: #001b3f">FAQ</h6>
        </a>
      </div>
    </div>
  </div>
</div> -->

<!-- navbar -->
<!-- <div *ngIf="isAuthenticated()">
  <app2-menu-desktop class="desktop"></app2-menu-desktop>
  <app2-menu-timeout></app2-menu-timeout>
</div> -->
<navbar></navbar>
<div class="col-md-12" id="sessionTimeoutModal" class="hideClass">
  <div class="col-md-12 alert alert-warning customTimeout">
    <strong>Info!</strong>
    {{ "global.messages.info.sessiontimeout" | translate }}
  </div>
</div>